import omit from "lodash-es/omit";

import {
    AD_SLOT_REGISTER,
    AD_SLOT_RENDER_ENDED,
    AD_SLOT_UNREGISTER,
    AdSlotRefreshAction,
    AdSlotRegisterAction,
    AdSlotRenderEndedAction,
    AdSlotUnregisterAction,
} from "@/mk2/containers/AdSlot/AdSlot.actions";
import { ZoneTargeting } from "@/mk2/containers/AdSlot/interfaces";

export interface AdSlotsState {
    [slotId: string]: AdSlotState;
}

export const initialAdSlotsState: AdSlotsState = {};

export interface AdSlotState {
    zone: string;
    targeting: ZoneTargeting;
    lastRefresh?: Date;
    lastSize?: number[] | string;
    isEmpty?: boolean;
}

type AdSlotActions =
    | AdSlotRegisterAction
    | AdSlotUnregisterAction
    | AdSlotRenderEndedAction
    | AdSlotRefreshAction;

export const adSlotReducer = (state: AdSlotsState = {}, action: AdSlotActions): AdSlotsState => {
    switch (action.type) {
        case AD_SLOT_REGISTER:
            if (state[action.slotId]) {
                // Ignore if already registered
                return state;
            }

            return {
                ...state,
                [action.slotId]: {
                    zone: action.zone,
                    targeting: action.targeting,
                },
            };
        case AD_SLOT_UNREGISTER:
            if (!state[action.slotId]) {
                // Not registered
                return state;
            }

            return omit(state, action.slotId);
        case AD_SLOT_RENDER_ENDED:
            if (!state[action.slotId]) {
                // Not registered
                return state;
            }
            return {
                ...state,
                [action.slotId]: {
                    ...state[action.slotId],
                    lastRefresh: new Date(),
                    lastSize: action.event?.size,
                    isEmpty: action.event?.isEmpty,
                },
            };
        default:
            return state;
    }
};
